import React from "react"
import { Link } from 'react-router-dom'
import Facebook from "../../assets/images/Facebook.png"
import Twitter from "../../assets/images/Twitter.png"
import GooglePlay from "../../assets/images/googleplay.png"
import Github from "../../assets/images/Github.png"
import Logo from "../../assets/images/healthify-logo.png"

function Footer() {
  const footerLinks = [
    {
      text: "JOIN US",
      location: "/coming-soon",
      class: "link",
    },
    {
      text: "DONATE",
      location: "/coming-soon",
      class: "link",
    },
    {
      text: "ABOUT",
      location: "/about",
      class: "link",
    },
    {
      text: "CONTACT",
      location: "/coming-soon",
      class: "link",
    },
  ]

  return (
    <footer className="footer">
      <div className="footer__content">

        {/*  */}
        <img src={GooglePlay} alt="" />

        <div className="footer__links ">

          <img src={Logo} alt="" />
          {footerLinks.map((footerLink, index) => {
            return (
              <Link key={index} to={footerLink.location}>{footerLink.text}</Link>
            )
          })}
        </div>
        <div className="social__links ">
          <div className="icons">
            <Link to="/" className="icon">
              <img src={Facebook} alt="" />
            </Link>
            <Link to="/" className="icon">
              <img src={Twitter} alt="" />
            </Link>
            <Link
              to="/"
              className="icon"
            >
              <img src={Github} alt="" />
            </Link>
          </div>

        </div>
      </div>

    </footer>
  )
}

export default Footer
